var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.2216C1.47452e-08 15.5469 0.551034 15 1.23077 15L30.7692 15C31.449 15 32 15.5469 32 16.2216C32 16.8962 31.449 17.4432 30.7692 17.4432L1.23077 17.4432C0.551034 17.4432 -1.47452e-08 16.8962 0 16.2216Z",
    fill: "#FF003D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7784 0C16.4531 1.47452e-08 17 0.551034 17 1.23077V30.7692C17 31.449 16.4531 32 15.7784 32C15.1038 32 14.5568 31.449 14.5568 30.7692L14.5568 1.23077C14.5568 0.551034 15.1038 -1.47452e-08 15.7784 0Z",
    fill: "#FF003D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorAdd);
export default __webpack_public_path__ + "static/media/vector_add.85c89b2c64a5809716c975b0b8f6276a.svg";
export { ForwardRef as ReactComponent };